import request from '@/utils/request'
// const server = "/cloudhealth-server-portal"
import Vue from 'vue'
const server = "/business";

//患者检查列表
export function getExamReportInfos(query) {
  return request({
    url: server+'/healthinfo/getExamReports',
    method: 'post',
    data: query
  })
}

export function turnToPageExamReportInfos(query) {
  return request({
    url: server+'/healthinfo/getExamReports?page=' + query.pageNum + '&pageSize=' + query.pageSize,
    method: 'post',
    data: query
  })
}

//获取患者检查详细信息
export function getExamReportDetail(id) {
  return request({
    url: server+'/healthinfo/getExamReportDetail',
    method: 'get',
    params: {id:id}
  })
}

export function getExamItems(query) {
  return request({
    url: server+'/healthinfo/getExamReportItems',
    method: 'get',
    params: query
  })
}

export function removePersonalExamItems(query) {
  return request({
    url: server+'/healthinfo/removePersonalExamItems',
    method: 'post',
    params: query
  })
}

export function addPersonalExamItems(query) {
  return request({
    url: server+'/healthinfo/addPersonalExamItems',
    method: 'post',
    params: query
  })
}

export function updatePersonalExamItem(query) {
  return request({
    url: server+'/healthinfo/updatePersonalExamItem',
    method: 'post',
    params: query
  })
}

